import { EXO_SKELETON_RUNTIME_SCOPE, EXO_SKELETON_EVENT_NAMES } from './consts';
export { getExoSkeletonRemotesUrl } from './helpers/getExoSkeletonRemotesUrl';
export function getExoSkeletonRuntime() {
  let host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  if (!host[EXO_SKELETON_RUNTIME_SCOPE]) {
    host[EXO_SKELETON_RUNTIME_SCOPE] = {};
  }
  return host[EXO_SKELETON_RUNTIME_SCOPE];
}

/**
 * Should be used by an ExoSkeleton host
 */
export function setIsInExoSkeleton() {
  const runtime = getExoSkeletonRuntime();
  runtime.available = true;
}
export function createUniqueRequestId() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(prefix).concat(Math.random().toString(16).slice(2));
}
export function getRemoteRuntime(scope) {
  var _runtime$remotes;
  const runtime = getExoSkeletonRuntime();
  return runtime === null || runtime === void 0 ? void 0 : (_runtime$remotes = runtime.remotes) === null || _runtime$remotes === void 0 ? void 0 : _runtime$remotes[scope];
}
export function removeExoSkeletonRuntime() {
  delete window[EXO_SKELETON_RUNTIME_SCOPE];
}
export { EXO_SKELETON_EVENT_NAMES };
//# sourceMappingURL=internal.js.map